// all-tags-modal.js
;(({ $, $$, log }) => {
    $$('.js-all-tags-modal-trigger').forEach(trigger => {
        const rawData = trigger.dataset.json
        if (!rawData) return

        const data = JSON.parse(rawData)
        
        trigger.addEventListener('click', e => {
            e.preventDefault()

            const container = $('#all-tags-compact')
            const sectionsBody = container?.querySelector('.all-tags-compact__body')
            const sectionsHeader = container?.querySelector('.all-tags-compact__header-url')

            if (!sectionsBody || !sectionsHeader) return

            sectionsBody.innerHTML = createSectionsBodyString(data)
            sectionsHeader.innerHTML = createSectionsHeaderUrlString(data)
            CNS.$fns.openAllTagsModal(trigger)
        })
    })

    function createSectionsHeaderUrlString({ server_name, server_url }) {
        return `<a href="${server_url}" class="all-tags-compact__server-name">${server_name}</a>`
    }

    function createSectionsBodyString({ sections }) {
        return sections.map(s => `<div class="all-tags-compact__section">
                        <span class="all-tags-compact__label">${s.name}</span>
                        <div class="all-tags-compact__tags">${createTagsString(s)}</div>
                    </div>`).join('')
    }

    function createTagsString({ tags }) {
        return tags.map(t => {
            return `<div class="tag">${t}</div>`
        }).join('')
    }
})(CNS);